import moment from 'moment'
import { practicesGET, REMBLE_API_URL } from '.'

const BASE_URL = `${REMBLE_API_URL}/lms/wp-json`

/* =============================================
 * Public helpers
 * ============================================= */

/**
 * Returns an array of Daily Remble videos from the REST API,
 * optionally filtered by the passed in queryObj and modified by the passed in paramObj
 * @param {Object} queryObj The query object to filter the videos by
 * @param {Object} paramObj The param object to modify the videos or modify the response
 **/
const getDailyRembleVideos = async (queryObj = null, paramObj = null) => {
  const uri = `/wp/v2/daily_remble`
  const practice = await practicesGET(
    BASE_URL,
    { uri, per_page: 100, no_cache: true },
    paramObj
  )

  // Sort so that the newest is always first
  return practice.sort((a, b) => moment(b.date).diff(moment(a.date)))
}

/**
 * Returns an array of Daily Remble video IDs that the user has already watched
 */
const getWatchedDailyRembleVideos = () => {
  // Get the current video list
  const watchedVideos = JSON.parse(
    localStorage.getItem('watchedDailyRembleVideos') || '[]'
  )

  // Return unique IDs
  return watchedVideos
}

/**
 * Updates local storage to indicate that the current video has been completed
 * @param {Number} videoId The ID of the video that has been watched
 */
const updateWatchedDailyRembleVideos = videoId => {
  // If we don't have an ID don't save anything
  if (!videoId) return

  const watchedVideos = getWatchedDailyRembleVideos()

  // Don't add the video if it's already in the list
  if (watchedVideos.includes(videoId)) return

  // Update the local storage
  localStorage.setItem(
    'watchedDailyRembleVideos',
    JSON.stringify([...new Set([...watchedVideos, videoId])])
  )
}

export {
  getDailyRembleVideos,
  getWatchedDailyRembleVideos,
  updateWatchedDailyRembleVideos
}
